(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["briz-faq"]) return;
  try {
    
(function () {
  /* Accordion — one open at a time per panel */
  document.querySelectorAll('.bfaq-q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = this.closest('.bfaq-panel');
      var isExpanded = this.getAttribute('aria-expanded') === 'true';
      if (panel) {
        panel.querySelectorAll('.bfaq-q').forEach(function (b) {
          b.setAttribute('aria-expanded', 'false');
          b.nextElementSibling.classList.remove('is-open');
        });
      }
      if (!isExpanded) {
        this.setAttribute('aria-expanded', 'true');
        this.nextElementSibling.classList.add('is-open');
      }
    });
  });

  /* Category tabs */
  var cats = document.querySelectorAll('.bfaq-cat');
  cats.forEach(function (cat) {
    cat.addEventListener('click', function () {
      var targetId = this.getAttribute('aria-controls');
      cats.forEach(function (c) {
        c.classList.remove('is-active');
        c.setAttribute('aria-selected', 'false');
      });
      document.querySelectorAll('.bfaq-panel').forEach(function (p) {
        p.classList.remove('is-active');
      });
      this.classList.add('is-active');
      this.setAttribute('aria-selected', 'true');
      var panel = document.getElementById(targetId);
      if (panel) { panel.classList.add('is-active'); }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
